<template>
  <el-row>
    <el-col>
      <el-breadcrumb separator="/" class="admincrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统</el-breadcrumb-item>
        <el-breadcrumb-item>商户设置</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="商户管理" name="merchant">
          <el-col>
             <el-card class="box-card">
              <div class="text item">
                  <span class="corpinfo"><i class="fa fa-id-card-o"></i>{{ merchant.corpName }}</span>
              </div>
              <div class="text item">
                <el-form :model="merchant" ref="merchant" label-width="100px" class="merchantForm">
                  <el-form-item label="公司名" prop="corpName">
                    <el-input v-model="merchant.corpName" placeholder="请输入公司名"></el-input>
                  </el-form-item>
                  <el-form-item label="企业邮箱" prop="email">
                    <el-input v-model="merchant.email" placeholder="请输入企业邮箱"></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话" prop="tel">
                    <el-input v-model="merchant.tel" placeholder="请输入联系电话"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人" prop="contractName">
                    <el-input v-model="merchant.contractName" placeholder="请输入联系人"></el-input>
                  </el-form-item>
                  <el-form-item label="国家代码" prop="countryCode">
                    <el-input v-model="merchant.countryCode" placeholder="请输入国家代码,如US"></el-input>
                  </el-form-item>
                  <el-form-item label="所在省份" prop="province">
                    <el-input v-model="merchant.province" placeholder="请输入公司名"></el-input>
                  </el-form-item>
                  <el-form-item label="所在城市" prop="city">
                    <el-input v-model="merchant.city" placeholder="请输入所在城市"></el-input>
                  </el-form-item>
                  <el-form-item label="详细地址" prop="addressOne">
                    <el-input v-model="merchant.addressOne" placeholder="请输入详细地址"></el-input>
                  </el-form-item>
                  <el-form-item label="邮政编码" prop="postCode">
                    <el-input v-model="merchant.postCode" placeholder="请输入邮政编码"></el-input>
                  </el-form-item>
                  <el-form-item label="公司税号" prop="vatCode">
                    <el-input v-model="merchant.vatCode" placeholder="请输入公司税号"></el-input>
                  </el-form-item>
                  <el-form-item label="发票抬头" prop="invoiceHead">
                    <el-input v-model="merchant.invoiceHead" placeholder="请输入发票抬头"></el-input>
                  </el-form-item>
                  <el-form-item style="text-align: right;">
                    <el-button type="primary" @click="merchantSubmit" label="right">立即更新</el-button>
                    <el-button>取消</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-card>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="店铺管理" name="shop">
          <el-col>
             <el-card class="box-card">
              <div class="text item">
                  <span class="shopinfo"><i class="fa fa-shopping-cart"></i>{{ spinfo.shortName }}
                    <span class="staticon" v-if="spinfo.corpNmae" style="color: #67C23A; font-size: 14px;"><i class="el-icon-success"></i>已激活</span>
                    <span class="staticon" v-else style="color: #F56C6C;"><i class="el-icon-error font-size: 14px"></i>未激活</span>
                  </span>
              </div>
              <div class="text item">
                <el-form :model="spinfo" ref="spinfo" label-width="100px" class="spinfo">
                  <el-form-item label="店铺标题" prop="shopName">
                    <el-input v-model="spinfo.shopName" placeholder="请输入店铺标题"></el-input>
                  </el-form-item>
                   <el-form-item label="店铺副标题" prop="subTitle">
                    <el-input v-model="spinfo.subTitle" placeholder="请输入店铺副标题"></el-input>
                  </el-form-item>
                  <el-form-item prop="supportCurrency" label="店铺支持货币">
                    <el-input type="textarea" :rows="6" v-model="spinfo.supportCurrency" placeholder="请输入店铺支持的货币代码(三位国际标准码,如USD,CNY),并使用大写,多货币使用英文半角逗号分隔"></el-input>
                  </el-form-item>
                  <el-form-item label="店铺简称" prop="shortName">
                    <el-input v-model="spinfo.shortName" placeholder="请输入店铺简称"></el-input>
                  </el-form-item>
                  <el-form-item label="店铺logo" prop="logo">
                    <el-upload
                      class="avatar-uploader"
                      :data="uploadattr"
                      accept="image/*"
                      name="upload"
                      :headers="$verifyhead"
                      :action="upurl"
                      :show-file-list="false"
                      :on-success="handleLogoSuccess">
                      <img v-if="spinfo.logo" :src="spinfo.logo" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <el-input v-model="spinfo.logo" style="display: none"></el-input>
                  </el-form-item>
                  <el-form-item label="店铺手机端logo" prop="logo">
                    <el-upload
                      class="avatar-uploader"
                      :data="uploadattr"
                      accept="image/*"
                      name="upload"
                      :headers="$verifyhead"
                      :action="upurl"
                      :show-file-list="false"
                      :on-success="handleMobileLogoSuccess">
                      <img v-if="spinfo.mobilelogo" :src="spinfo.mobilelogo" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <el-input v-model="spinfo.mobilelogo" style="display: none"></el-input>
                  </el-form-item>
                  <el-form-item label="店铺图标" prop="shortcut">
                    <el-upload
                      class="avatar-uploader"
                      :data="uploadattr"
                      accept="image/*"
                      name="upload"
                      :headers="$verifyhead"
                      :action="upurl"
                      :show-file-list="false"
                      :on-success="handleShortcutSuccuss">
                      <img v-if="spinfo.shortcut" :src="spinfo.shortcut" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <el-input v-model="spinfo.shortcut" style="display: none"></el-input>
                  </el-form-item>
                  <el-form-item label="加载图标" prop="shortcut">
                    <el-upload
                      class="avatar-uploader"
                      :data="uploadattr"
                      accept="image/*"
                      headers="$verifyhead"
                      name="upload"
                      :action="upurl"
                      :show-file-list="false"
                      :on-success="handleLoadingIcontSuccuss">
                      <img v-if="spinfo.loading" :src="spinfo.loading" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <el-input v-model="spinfo.loading" style="display: none"></el-input>
                  </el-form-item>
                  <el-form-item label="店铺关键词" prop="keyWords">
                    <el-input v-model="spinfo.keyWords" placeholder="请输入店铺关键词"></el-input>
                  </el-form-item>
                  <el-form-item label="店铺描述" prop="description">
                    <el-input v-model="spinfo.description" placeholder="请输入店铺描述"></el-input>
                  </el-form-item>
                   <el-form-item label="分享代码" prop="sharescript">
                    <el-input type="textarea" :rows="5" v-model="spinfo.sharescript" placeholder="请输入分享代码"></el-input>
                  </el-form-item>
                   <el-form-item label="粉丝代码" prop="followscript">
                    <el-input type="textarea" :rows="5" v-model="spinfo.followscript" placeholder="请输入粉丝代码"></el-input>
                  </el-form-item>
                  <el-form-item label="店铺公司" prop="corpNmae">
                    <el-input v-model="spinfo.corpNmae" placeholder="请输入店铺公司"></el-input>
                  </el-form-item>
                  <el-form-item label="店铺货币" prop="currency">
                    <el-input v-model="spinfo.currency" placeholder="请输入店铺货币,如USD"></el-input>
                  </el-form-item>
                  <el-form-item label="店铺国家" prop="CountryCode">
                    <el-input v-model="spinfo.CountryCode" placeholder="请输入店铺国家,如US"></el-input>
                  </el-form-item>
                  <el-form-item label="店铺地址" prop="CountryCode">
                    <el-input v-model="spinfo.address" placeholder="请输入店铺地址"></el-input>
                  </el-form-item>
                  <el-form-item style="text-align: right;">
                    <el-button type="primary" @click="shopSubmit" label="right">立即更新</el-button>
                    <el-button>取消</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-card>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="站点配置" name="sites">
          <span><h2>网站域名</h2></span>
          <el-table :data="sites" size="mini" stripe>
            <el-table-column label="ID" prop="ID" width="120"></el-table-column>
            <el-table-column label="域名" width="280">
              <template slot-scope="scope">
                <h4>{{scope.row.domain}}</h4>
              </template>
            </el-table-column>
            <el-table-column label="PC域名">
              <template slot-scope="scope">
                <span v-if="scope.row.defaultadmain" style="font-size: 12px; color: green; font-weight: bolder;">是</span>
                 <span v-else style="font-size: 12px; color: red; font-weight: bolder;">否</span>
              </template>
            </el-table-column>
            <el-table-column label="移动端域名">
              <template slot-scope="scope">
                <span v-if="scope.row.mobiledomain" style="font-size: 12px; color: green; font-weight: bolder;">是</span>
                 <span v-else style="font-size: 12px; color: red; font-weight: bolder;">否</span>
              </template>
            </el-table-column>
            <el-table-column label="域名管理" fixed="right" width="430" align="right">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button type="text" @click="handleDomainStatus(scope.row.ID)">删除当前域名</el-button>
                  <el-button type="text" @click="handleDomainUpdate('mobile', scope.row.ID)">设置为手机默认域名</el-button>
                  <el-button type="text" @click="handleDomainUpdate('pc', scope.row.ID)">设置为PC端默认域名</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 26px; margin-bottom: 26px; font-size: 10px;"><i class="fa fa-tag"></i>自主管理域名请绑定至domain.bigevy.com</div>
          <div style="display: block; text-align: right;">
              <el-button type="success" @click="showaddform">绑定域名</el-button>
          </div>
          <el-dialog :visible.sync="adddomainshow" :before-close="handleClose" width="30%">
            <span>
                <el-form name="sitedomain" :model = "sitedomain" ref= "sitedomain">
                  <el-form-item label="分类名称" prop="name">
                    <el-input v-model="sitedomain.domains" type="textarea" placeholder="请输入系统名称,多个域名，一行一个" required></el-input>
                  </el-form-item>
                  <el-form-item style="text-align: right">
                    <el-button @click="adddomainshow = false">取 消</el-button>
                    <el-button type="primary" @click="applyadmains('sitedomain')">确 定</el-button>
                  </el-form-item>
                </el-form>
              </span>
          </el-dialog>
          <el-form :model="scriptdata" ref="scriptdata" label-width="100px" style="margin-top: 56px;">
            <el-form-item label="头部脚本" prop="header">
              <el-input v-model="scriptdata.header" placeholder="请输入头部脚本" type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="底部脚本" prop="footer">
              <el-input v-model="scriptdata.footer" placeholder="请输入底部脚本" type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="分享脚本" prop="share">
              <el-input v-model="scriptdata.share" placeholder="请输入社交分享脚本" type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="转化脚本" prop="ordertrack">
              <el-input v-model="scriptdata.ordertrack" placeholder="请输入购物车转化跟踪脚本,相应的跟踪参数请使用模板标签替换，详细请查看使用文档" type="textarea"></el-input>
            </el-form-item>
            <el-form-item style="text-align: right;">
              <el-button type="success" @click="scriptSubmit('scriptdata')" label="right"><i class="fa fa-edit"></i>立即更新</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="网站验证" name="websiteverify">
          <el-col :span="16">
              <el-col :span="24">
                <el-table :data="tabledata"  stripe style="width: 100%">
                  <el-table-column prop="ID" label="ID" width="110"></el-table-column>
                  <el-table-column prop="name" label="路由名称" width="150"></el-table-column>
                  <el-table-column prop="uri" label="路由地址" width="200"></el-table-column>
                  <el-table-column prop="txt" label="路由内容" width="300"></el-table-column>
                  <el-table-column fixed="right" label="操作" width="250">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="editroute('scope.row')">编辑</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="24" class="pagenav" style="margin-top: 42px;">
                <el-pagination
                @current-change="handleCurrentPageChange"
                :current-page="currPage.page"
                :page-sizes="[15]"
                :page-size="15"
                layout="total, sizes, prev, pager, next, jumper"
                :total="currPage.total">
              </el-pagination>
            </el-col>
          </el-col>
          <el-col :span="8">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>新增路由器</span>
              </div>
              <div class="body">
                <el-form :model="routedata" ref="routedata" label-width="100px" style="margin-top: 56px;">
                  <el-form-item label="路由名称" prop="name">
                    <el-input v-model="routedata.name" placeholder="请输入路由名称" type="text" :rules="{required: true, message: '请输入路由名称', trigger: 'blur'}"></el-input>
                  </el-form-item>
                  <el-form-item label="路由地址" prop="uri">
                    <el-input v-model="routedata.uri" placeholder="请输入路由地址" type="text" :rules="{required: true, message: '请输入路由地址', trigger: 'blur'}"></el-input>
                  </el-form-item>
                  <el-form-item label="路由内容" prop="desc">
                    <el-input v-model="routedata.txt" placeholder="请输入路由内容" :rows="5" type="textarea" :rules="{required: true, message: '请输入路由内容', trigger: 'blur'}"></el-input>
                  </el-form-item>
                  <el-form-item style="text-align: right;">
                    <el-button type="success" @click="submitRoute('routedata')" label="right"><i class="fa fa-edit"></i>新增路由器</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-card>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="社交媒体" name="oauth">
          <h2>社交媒体</h2>
          <el-form ref="socialFeom">
            <span v-for="(item, key) in socialdev" :key="key">
              <el-row style="border-bottom: 1px solid rgb(244,244,244); padding-bottom: 16px; margin-bottom: 16px;">
                 <h4>{{key}}</h4>
                <small>回调地址:https://youdomain/oauth</small>
              </el-row>
              <el-form-item v-for="(kv, ks) in item" :key="ks" :label="ks" :prop="key + '.' + ks">
                <el-input v-model="socialdev[key][ks]" :value="kv" :placeholder="'请输入' + key + '平台开发者' + ks + '值'"/>
              </el-form-item>
            </span>
            <el-form-item style="text-align: right;">
              <el-button type="primary" @click="handsocial"><i class="fa fa-hand-grab-o"></i>更新社交媒体开发者信息</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
</template>
<script>
export default {
  name: 'Account',
  data () {
    return {
      activeName: 'merchant',
      upurl: this.$apiurl,
      uploadattr: {method: 'base.upload'},
      merchant: {},
      spinfo: {shopName: '未指定店铺名称'},
      loading: true,
      sysOptionData: {},
      sites: [],
      sitedomain: {},
      adddomainshow: false,
      scriptdata: {},
      routedata: {},
      currPage: {},
      tabledata: [],
      s: {},
      initdm: {defaultadmain: '', mobiledomain: ''},
      socialdev: {},
      load: ''
    }
  },
  mounted: function () {
    this.loadMerchant()
    this.shopLoad()
    this.loadsites()
    this.loadscrip()
    this.handleCurrentPageChange(1)
    this.getSocialDevFields()
  },
  methods: {
    handleDomainUpdate: function (channel, siteId) {
      var that = this
      var para = {}
      para.channel = channel
      para.siteId = siteId
      para.method = 'shop.defaultsitedoamin'
      that.fullLoad()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.hasloaded()
        if (ret.body.data.code === 200) {
          that.$message.success('域名信息更新成功')
          that.loadsites()
        } else {
          that.$message.error('域名信息更新失败')
        }
      })
    },
    hasloaded: function () {
      this.load.close()
      this.load = ''
    },
    fullLoad () {
      this.load = this.$loading({
        lock: true,
        text: '请求处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    handsocial: function () {
      var that = this
      that.fullLoad()
      var para = {}
      Object.assign(para, that.socialdev)
      para.method = 'shop.socialdevupdate'
      console.log(para)
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.hasloaded()
        if (ret.body.data.code === 200) {
          that.$message.success('社交信息更新成功')
        } else {
          that.$message.success('社交信息更新失败')
        }
      })
    },
    getSocialDevFields: function () {
      var that = this
      that.$http.post(that.$apiurl, {method: 'shop.socialoauthoptions'}).then(function (ret) {
        var md = ret.body.data
        var currdev = that.socialdev
        md.forEach(function (curr, index) {
          console.log(curr.code)
          if (!currdev[curr.code]) {
            console.log('规则不存在')
            var tk = {}
            curr.fields.forEach(function (item, bh) {
              tk[item.field] = ''
            })
          } else {
            console.log('规则已经存在')
            curr.fields.forEach(function (item, bh) {
              var tk = {}
              if (currdev[curr.code][item.field] === undefined) {
                tk[item.field] = ''
              } else {
                tk[item.field] = currdev[curr.code][item.field]
              }
            })
          }
          that.$set(that.socialdev, curr.code, tk)
        })
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleClick (tab, event) {
      console.log('aaa')
    },
    loadMerchant: function () {
      var that = this
      this.$http.post(that.$apiurl, {method: 'base.merchantinformation'}).then(function (ret) {
        var dd = ret.body.data
        if (!dd.sysOptionData) {
          dd.sysOptionData = {}
        }
        that.merchant = dd
        try {
          that.sysOptionData = JSON.parse(ret.body.data.options)
        } catch (e) {
          that.sysOptionData = {}
        }
      })
    },
    merchantSubmit: function (event) {
      event.preventDefault()
      var data = this.merchant
      data['method'] = 'base.merchantupdate'
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        if (ret.body.code === 200) {
          this.$message.success('商户信息更新成功!')
        } else {
          this.$alert('商户信息更新失败，请稍后重试!')
        }
      })
    },
    shopLoad: function () {
      var that = this
      this.$http.post(that.$apiurl, {method: 'base.shopinformation'}).then(function (ret) {
        if (ret.body !== null) {
          that.spinfo = ret.body.data
          if (ret.body.data.socialdev) {
            that.socialdev = ret.body.data.socialdev
          }
        }
      })
    },
    shopSubmit: function (event) {
      event.preventDefault()
      var data = this.spinfo
      delete data.socialdev
      data['method'] = 'base.shopupdate'
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        if (ret.body.code === 200) {
          this.$message.success('店铺信息更新成功!')
        } else {
          this.$alert('店铺信息更新失败，请稍后重试!')
        }
      })
    },
    optionSubmit: function () {
      var data = this.sysOptionData
      data['method'] = 'base.sysoption'
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        if (ret.body.data.code === 200) {
          this.$message.success('店铺信息更新成功!')
        } else {
          this.$alert('店铺信息更新失败，请稍后重试!')
        }
      })
    },
    handleLogoSuccess: function (response, file, fileList) {
      var that = this
      this.$set(that.spinfo, 'logo', response.data.url)
    },
    handleMobileLogoSuccess: function (response, file, fileList) {
      var that = this
      this.$set(that.spinfo, 'mobilelogo', response.data.url)
    },
    handleShortcutSuccuss: function (response, file, fileList) {
      var that = this
      this.$set(that.spinfo, 'shortcut', response.data.url)
    },
    handleLoadingIcontSuccuss: function (response, file, fileList) {
      var that = this
      this.$set(that.spinfo, 'loading', response.data.url)
    },
    loadsites: function () {
      var para = {}
      para.method = 'shop.sites'
      var that = this
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.sites = ret.body.data
        var sts = ret.body.data
        console.log(sts)
      })
    },
    applyadmains: function (form) {
      var that = this
      that.$refs[form].validate(function (valid) {
        if (valid) {
          var para = that.sitedomain
          para.method = 'shop.addnewdomain'
          that.$http.post(that.$apiurl, para).then(function (ret) {
            if (ret.body.data.code === 200) {
              this.$message.success('店铺信息更新成功!')
              that.loadsites()
              that.adddomainshow = false
            } else {
              this.$alert('店铺信息更新失败，请稍后重试!')
            }
          })
        }
      })
    },
    showaddform: function () {
      this.adddomainshow = true
    },
    handleDomainStatus: function (siteid) {
      var that = this
      var para = {}
      para.method = 'shop.removedomain'
      para.siteid = siteid
      that.$http.post(that.$apiurl, para).then(function (ret) {
        if (ret.body.data.code === 200) {
          this.$message.success('域名信息更新成功!')
          that.loadsites()
          that.adddomainshow = false
        } else {
          this.$alert('域名信息更新失败，请稍后重试!')
        }
      })
    },
    scriptSubmit: function (fn) {
      var that = this
      var para = {}
      Object.assign(para, that.scriptdata)
      para.method = 'shop.scriptinsert'
      that.$http.post(that.$apiurl, para).then(function (ret) {
        if (ret.body.data.code === 200) {
          this.$message.success('店铺信息更新成功!')
          that.loadscrip()
        } else {
          this.$alert('店铺信息更新失败，请稍后重试!')
        }
      })
    },
    loadscrip: function () {
      var para = {}
      para.method = 'shop.scripall'
      var that = this
      that.$http.post(that.$apiurl, para).then(function (ret) {
        if (ret.body.data) {
          that.scriptdata = ret.body.data
        } else {
          that.scriptdata = {header: '', footer: '', share: '', ordertrack: ''}
        }
      })
    },
    submitRoute: function (fm) {
      var that = this
      that.$refs[fm].validate(function (valid) {
        if (valid) {
          var para = {}
          Object.assign(para, that.routedata)
          para.method = 'shop.addverifypage'
          that.$http.post(that.$apiurl, para).then(function (ret) {
            if (ret.body.data.code === 200) {
              this.$message.success('店铺信息更新成功!')
              that.handleCurrentPageChange(1)
            } else {
              this.$alert('店铺信息更新失败，请稍后重试!')
            }
          })
        }
      })
    },
    handleCurrentPageChange: function (page) {
      var data = this.s
      data['page'] = page
      data['num'] = 15
      data['method'] = 'shop.verifypagelist'
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.$set(that.currPage, 'page', ret.body.data.page)
        that.$set(that.currPage, 'total', ret.body.data.total)
        that.tabledata = ret.body.data.data
      })
    },
    editroute: function (row) {
    }
  }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/merchant/Merchant.vue